import {Component, OnDestroy, OnInit} from '@angular/core';
import {RewardsAdminService} from '../../../../services/rewards-admin/rewards-admin.service';
import {Router} from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-superadmin-rewards-rebates',
  templateUrl: './superadmin-rewards-rebates.component.html',
  styleUrls: ['./superadmin-rewards-rebates.component.scss'],
})
export class SuperadminRewardsRebatesComponent implements OnInit, OnDestroy {
  public items: any[] = [];
  public searchValue = '';
  public page = 1;
  public limit = 30;
  public endOfList = false;
  public loading = false;
  private readonly searchDebounceMs = 300;
  private readonly searchValueChanges = new Subject<string>();
  private readonly searchSubscription: Subscription;

  constructor(
    private rewardsAdminService: RewardsAdminService,
    private router: Router,
  ) {
    this.searchSubscription = this.searchValueChanges
      .pipe(
        debounceTime(this.searchDebounceMs),
        distinctUntilChanged(),
      )
      .subscribe(() => this.loadItems(true));
  }

  ngOnInit(): void {
    this.loadItems(true);
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  async loadItems(clear = false): Promise<void> {
    if (clear) {
      this.page = 1;
      this.endOfList = false;
      this.items = [];
    }
    if (this.loading || this.endOfList) {
      return;
    }
    this.loading = true;
    try {
      const rebates = await this.rewardsAdminService.getPurchasedRewards(this.searchValue, this.page, this.limit);
      if (!rebates || rebates.length === 0) {
        this.endOfList = true;
      } else {
        this.items = this.items.concat(rebates);
        this.page += 1;
      }
    } catch (error) {
      console.error('Error loading rebates', error);
    } finally {
      this.loading = false;
    }
  }

  queueFilter(value: string): void {
    this.searchValueChanges.next((value || '').toString());
  }

  addRebate(): void {
    this.router.navigate(['/superadmin/rewards/rebate/new']).then();
  }

  editRebate(reward: any): void {
    this.router.navigate(['/superadmin/rewards/rebate', reward.id]).then();
  }

  onScroll(event: any): void {
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    const offsetHeight = event.target.offsetHeight;
    const threshold = 150;
    if (scrollTop + offsetHeight >= scrollHeight - threshold) {
      this.loadItems();
    }
  }
}
